import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { RenderButton } from 'pages/payment-success/components/render-button'

import { Loader } from 'shared/ui/loader'

import styles from './styles.module.scss'

type Props = {
  onClick: () => void
}

export const UmrahPending = ({ onClick }: Props) => {
  const { t } = useTranslation()
  return (
    <div className={clsx('safe-area-top-padding', styles.containerPending)}>
      <Loader />

      <p className={clsx(styles.text, 'semi-bold-16')}>
        {t('payment_success.payment_loading')}
      </p>

      <p className={clsx(styles.textDesc, 'medium-14')}>
        {t('payment_success.payment_loading_des')}
      </p>

      <RenderButton
        text={t('go_home')}
        onClick={onClick}
      />
    </div>
  )
}
